@let loaded = !loading() && !error();
@let isDisclaimerVisible = loaded && (headerDisclaimer() || headerDisclaimerTitle());

<div class="common-section-layout-container">
  @if (isDisclaimerVisible) {
    <cm-alert-card
      [icon]="headerDisclaimerIcon()"
      [iconSize]="'s'"
      [title]="headerDisclaimerTitle()"
      [subtitle]="headerDisclaimer()"
      [collapsible]="collapsible()"
      [initiallyExpanded]="disclaimerInitiallyExpanded()"
    >
      <ng-content select="[headerContent]" />
    </cm-alert-card>
  }

  <div class="common-section-layout">
    @if (loaded && (title() || description() || hasBackButton())) {
      <cm-sub-header-layout
        [title]="title()"
        [titleLevel]="titleLevel()"
        [visualTitleLevel]="visualTitleLevel()"
        [subtitle]="description()"
        [subtitleHtml]="descriptionHtml()"
        [hasBackButton]="hasBackButton()"
        [customBackHandler]="customBackHandler()"
        [showBreadcrumb]="showBreadcrumb()"
        (backButtonClick)="onBackButtonClick()"
      >
        <ng-content select="[actions]"></ng-content>
      </cm-sub-header-layout>
    }

    <!-- Actions rendered below the header instead of beside the title. Sits
         outside cm-section-data on purpose, so it stays visible in the empty
         and error states. -->
    <ng-content select="[sectionActions]"></ng-content>

    <cm-section-data
      [loading]="loading()"
      [empty]="empty()"
      [error]="error()"
      [skeletonLoaderPreset]="skeletonLoaderPreset()"
      [loadingTemplate]="loadingTemplate()"
      [emptyPreset]="emptyPreset()"
      [emptyIcon]="emptyIcon()"
      [emptyTitle]="emptyTitle()"
      [emptySubtitle]="emptySubtitle()"
      [emptyButtonLabel]="emptyButtonLabel()"
      [emptyButtonIcon]="emptyButtonIcon()"
      [emptyButtonLoading]="emptyButtonLoading()"
      [emptyUseCardContainer]="emptyUseCardContainer()"
      [errorTitle]="errorTitle()"
      [errorSubtitle]="errorSubtitle()"
      [errorButtonLabel]="errorButtonLabel()"
      [errorUseCardContainer]="errorUseCardContainer()"
      (emptyAction)="onEmptyAction()"
      (errorRefreshAction)="onErrorRefreshAction()"
    >
      <div class="layout-content" [class.layout-content--no-overflow-y]="overflowYDisabled()">
        <ng-content></ng-content>
      </div>
    </cm-section-data>
  </div>
</div>
